// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"443c79e6","225":"f2c97c10","787":"4e8d470b","947":"48454af1"}[chunkId] + ".chunk.js";
};